import { ready, onShopifySectionLoad } from '../utils/readyinit';
import initLoadMore from '../components/load-more';

ready(() => {
  initLoadMore();
});

onShopifySectionLoad(() => {
  initLoadMore();
});
